import { combineReducers } from '@reduxjs/toolkit'
import { otherCalendar } from './consultantsAvailability/reducers'

export const otherReducer = combineReducers({
	otherCalendar,
})
